import {
  Box,
  Button,
  ButtonGroup,
  Container,
  Flex,
  Stack,
} from "@chakra-ui/react";
import { useState } from "react";
import { CategoryChart } from "../components/CategoryChart";
import { DailyExpensesChart } from "../components/DailyExpenseChart";
import { MonthlyChart } from "../components/MonthlyChart";
import { YearOverviewChart } from "../components/YearOverviewChart";

export default function GeneralStatistics() {
  const [activeChart, setActiveChart] = useState<
    "yearly" | "monthly" | "daily" | "category"
  >("monthly");

  const renderChart = () => {
    switch (activeChart) {
      case "yearly":
        return <YearOverviewChart />;
      case "monthly":
        return <MonthlyChart />;
      case "daily":
        return <DailyExpensesChart />;
      case "category":
        return <CategoryChart />;
      default:
        return null;
    }
  };

  return (
    <Container maxW="lg" py={10} pb={{ base: 24, md: 10 }}>
      <Flex direction="column" align="center" width="100%">
        <Stack spaceY={2} align="center">
          {/*   <Heading textAlign="center" mb={4} ml={10}>
            FineCheck ✅
          </Heading> */}
          <ButtonGroup attached variant="outline" colorScheme="teal">
            <Button
              onClick={() => setActiveChart("monthly")}
              variant={activeChart === "monthly" ? "solid" : "outline"}
            >
              Monatsübersicht
            </Button>
            <Button
              onClick={() => setActiveChart("daily")}
              variant={activeChart === "daily" ? "solid" : "outline"}
            >
              Tagessummen
            </Button>
            <Button
              onClick={() => setActiveChart("category")}
              variant={activeChart === "category" ? "solid" : "outline"}
            >
              Kategorien
            </Button>
          </ButtonGroup>

          <Box mt={6} w="100%">
            {renderChart()}
          </Box>
        </Stack>
      </Flex>
    </Container>
  );
}
